import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";
import { formatNumber } from "@/utils/formatNumber";

interface DuplicateFilesDialogProps {
  open: boolean;
  duplicateCount: number;
  duplicateFiles: string[];
  onOverwrite: () => void;
  onSkip: () => void;
  onSkipAll: () => void;
}

export function DuplicateFilesDialog({
  open,
  duplicateCount,
  duplicateFiles,
  onOverwrite,
  onSkip,
  onSkipAll,
}: DuplicateFilesDialogProps) {
  return (
    <Dialog open={open}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <div className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-yellow-500" />
            <DialogTitle>Duplicate Files Found</DialogTitle>
          </div>
          <DialogDescription>
            {formatNumber(duplicateCount)} file{duplicateCount !== 1 ? 's' : ''} with the same name{duplicateCount !== 1 ? 's' : ''} already exist in your library.
          </DialogDescription>
        </DialogHeader>
        
        <div className="max-h-[200px] overflow-y-auto rounded-md border p-3">
          <ul className="space-y-1 text-sm">
            {duplicateFiles.map((filename, index) => (
              <li key={index} className="text-muted-foreground">
                {filename}
              </li>
            ))}
          </ul>
        </div>

        <DialogFooter className="flex flex-col gap-2 sm:flex-row sm:gap-2">
          <Button variant="outline" onClick={onSkip} className="flex-1">
            Skip These Files
          </Button>
          <Button variant="outline" onClick={onSkipAll} className="flex-1">
            Skip All Future
          </Button>
          <Button onClick={onOverwrite} className="flex-1">
            Overwrite Existing
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
